import React, {Component} from 'react';
import { Card,Button,Input,List} from 'antd';
import StuffCard from "./stuffCard";
import {uuid} from "../utils";
import { Scrollbars } from 'react-custom-scrollbars';
import {getRedirectXiumi, getStuffList} from "../actions/weiChat";
import {HEADER_HEIGHT} from "../constants";
const { Search } = Input;
class StuffList extends Component {

    defaultParams = {
        mediaCode: this.props.currentMedia?this.props.currentMedia:this.props.match.params.currentMedia,
        queryStr : "",
        start: 1,
        size: 12,
        currentEditStuffId : 0
    };

    constructor(props){
        super(props);
        this.state = {
            findAll : this.props.findAll,
            loading: true,
            data : [],
            isEditMaterial: this.props.isEditMaterial,
            total: 0
        }
    }

    componentDidMount() {
        this.loadStuffList(true);
    }

    updateDataOne(_stuff){
        let stuff = Object.assign({}, _stuff);
        this.setState(prevState=>{
            let newStuffList = [];
            for (let i = 0; i < prevState.data.length; i++) {
                let oldStuff = prevState.data[i];
                if(oldStuff.id === stuff.id){
                    stuff.openCheckedMode = false;
                    stuff.type = "big";
                    newStuffList.push(stuff);
                } else {
                    oldStuff.type = "big";
                    newStuffList.push(oldStuff);
                }
            }
            prevState.data = newStuffList;
            return prevState
        });
    }

    /**
     * 加载图文数据
     * @param reload   是否是清空后加载
     */
    loadStuffList = (reload) =>{
        this.setState({
            loading: true
        });
        let { findAll } = this.state;
        if(reload){
            getStuffList({...this.defaultParams,start : 1,findAll}, (res)=>{
                res.data.map(item=>item.uuid=item.uuid?item.uuid:uuid());
                this.setState({
                    data : res.data,
                    total : res.count,
                    loading: false
                })
            });
        }else {
            getStuffList({...this.defaultParams,findAll}, (res)=>{
                this.setState(prevState =>{
                    res.data.map(item=>item.uuid=item.uuid?item.uuid:uuid());
                    prevState.data.push(...res.data);
                    prevState.loading = false;
                    return prevState;
                })
            });
        }
    };

    insertStuff = () =>{
        // window.weChatEditCallBackParam = true;
        // window.weChatEditCallBack = this.loadStuffList;
        // getRedirectXiumi({"mediaId": 0,"currentMediaCode":this.defaultParams.mediaCode}, (res) => {
        //     window.addEventListener('message',function(e){
        //         if(e.data === 'close'){
        //             window.weChatEditCallBack(window.weChatEditCallBackParam);
        //         }
        //     },false);
        //     window.open(res);
        // });
        window.open("https://xiumi.us/studio/v5#/paper/for/new/cube/0");
    };

    show135Editor = (stuffId) => {
        // // let url = 'http://www.135editor.com/beautify_editor?callback=xxx';
        // // let url = '/cm-sites/pms/ueditor/135EditorDialogPage.html';
        // // window.open(url,'new_window','dialogHeight:750px; dialogWidth:1000px;help:No;resizable:No;status:No;scroll:Yes');
        // window.weChatEditCallBackParam = true;
        // window.weChatEditCallBack = this.loadStuffList;
        // let url = '#/wechat/135Edit/'+ this.defaultParams.mediaCode + '/' + stuffId;
        // window.open(url);
        window.open("https://www.135editor.com/");
    };

    /*监听滚动*/
    onScroll = e => {
        if(e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            // 滚动到底部需要做的事情
            this.defaultParams.start ++;
            this.loadStuffList(false);
        }
    };

    search = (value) =>{
        this.defaultParams.queryStr = value;
        this.loadStuffList(true);
    };

    render() {
        let border = 1;
        let cardMargin = 15;
        let cardPadding = this.state.isEditMaterial?10:24;
        let h = parseInt(HEADER_HEIGHT) + cardMargin * 2 + 64 + cardPadding * 2 + border * 2;
        let height = "calc(100vh - "+ h +"px)";
        if(this.props.contentHeight){
            height = this.props.contentHeight - (cardMargin * 2 + 64 + cardPadding * 2 + border * 2);
        }
        let width = "100%";
        return (
            <div>
                <Card
                    style={{ margin:cardMargin, height:"100%" }}
                    title={this.state.isEditMaterial?<Search placeholder="搜索" onSearch={value => this.search(value)} enterButton />:
                        <div><Button type="primary" onClick={this.insertStuff} style={{float:"left",marginRight:"10px"}}>秀米编辑</Button>
                            <Button type="primary" onClick={() => this.show135Editor(0)} style={{float:"left",marginRight:"10px"}}>135编辑</Button>
                        <div style={{fontSize: "14px",padding:"5px"}}>{"共" + this.state.total + "个图文"}</div></div>}
                    extra={this.state.isEditMaterial?"":<Search placeholder="搜索" onSearch={value => this.search(value)} enterButton />}
                    bodyStyle={{padding:this.state.isEditMaterial?10:cardPadding}}
                >
                    <Scrollbars
                        onScroll={this.onScroll.bind(this)}
                        autoHide
                        autoHideTimeout={1}
                        autoHideDuration={1}
                        style={{height,width}}>
                        <List
                            style={{overflowX:"hidden"}}
                            grid={this.state.isEditMaterial?{
                                gutter: 16,
                                xs: 1,
                                sm: 1,
                                md: 1,
                                lg: 1,
                                xl: 1,
                                xxl: 1,
                            }:{
                                gutter: 16,
                                xs: 1,
                                sm: 2,
                                md: 2,
                                lg: 2,
                                xl: 3,
                                xxl: 4,
                            }}
                            loading={this.state.loading}
                            dataSource={this.state.data}
                            renderItem={item => {
                                let stuffList = [item];
                                return (
                                    <List.Item>
                                        <StuffCard isEditMaterial={this.props.isEditMaterial}
                                                   addStuff={this.props.addStuff}
                                                   key={item.uuid?item.uuid:uuid()} stuffList={stuffList} showLock={!!item.materialId} updateDate={item.updateDate}
                                                   mediaCode={this.defaultParams.mediaCode} formId={item.fromId} fromStuff={true} stuffId={item.id}
                                                   reloadStuffList={this.loadStuffList} message={item.ftitle}/>
                                    </List.Item>
                                )
                            }}
                        />
                    </Scrollbars>
                </Card>
            </div>
        );
    }
}

StuffList.defaultProps = {
    isEditMaterial: false,
    findAll : true
};

export default StuffList;